import { ReactComponent as Gift } from "assets/icons/coming-soon.svg";
import { IS_REQUIRED_RE_OPEN_PWA, saveItem } from "local-storage";

export const UpdateVersion = (props: any) => {
  return (
    <div className="p-4 h-[100vh]">
      <div className="flex flex-col justify-center items-center gap-4 py-6 h-full">
        <div className="gap-2 flex flex-col justify-center items-center">
          <Gift className="w-24" />
          <div className="text-xl text-center">Update version</div>
          <div className="text-sm text-center text-slate-300 ">
            <span>Click 👇</span>
          </div>
          <button
            onClick={() => {
              saveItem(IS_REQUIRED_RE_OPEN_PWA, true);
              window?.location.reload();
            }}
          >
            Install version {props?.version}
          </button>
        </div>
      </div>
    </div>
  );
};
